import { nanoid } from 'nanoid/async'
import { videoModal } from './videoModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: fileData } = await videoModal(oldData, node)

  if (fileData && Object.values(fileData).length >= 2) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, fileData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}